import { VerticaisManager } from "src/components/vendas/VerticaisManager";
import { FormProjetoOffGridType, ListagemItem } from "../types";
import api from 'src/framework/providers/api'
import { IDataResponse } from "src/framework/providers/api";
import { ExtraInfoUsuario } from "src/providers/cadastros/ContaProvider/types";
import { DecimalUtil } from "src/framework/commons/DecimalUtils";
import { exibeJustificativaValorServico$ } from "src/store/vendas/projetos/store";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { TIPO_FATURAMENTO } from "../constants";

const projetosProvider = new ProjetosProvider();

export interface EstruturasGruposSalvar {
  quantidade: number;
  componente_id: number;
  estruturas_grupo_id: number;
  "@remove"?: boolean;
}

export interface ComponentesSalvar {
  componente_id: number;
  categoria_componentes_id: number;
  quantidade: number;
  valor_unitario: number;
  estruturas_grupos?: EstruturasGruposSalvar[];
  "@remove"?: boolean;
}

export interface EquipamentoConsumoSalvar {
  nome: string
  quantidade: number
  potencia: number
  horas_uso: number
  consumo_diaria: number
}

function formatarComponentesSalvar(items: ListagemItem[]): ComponentesSalvar[] {
  const comps: ComponentesSalvar[] = []
  for (const item of items) {
    comps.push({
      componente_id: Number(item.componente_id),
      categoria_componentes_id: Number(item.categoria_componentes_id),
      quantidade: Number(item.quantidade),
      valor_unitario: Number(item.valor),
  })   
  }
  return comps;
}

function converterParaKw(valor?: number): number {
  return (valor || 0) / 1000;
}

function formatarEstruturasSalvar(items: ListagemItem[]): ComponentesSalvar[] {
  const comps: ComponentesSalvar[] = []

  for (const item of items) {
    const alreadyAddedIndex = comps.findIndex(comp => comp.componente_id === item.componente_id)

    if (alreadyAddedIndex !== -1) {
      comps[alreadyAddedIndex].quantidade = comps[alreadyAddedIndex].quantidade + Number(item.quantidade)

      if (Array.isArray(comps[alreadyAddedIndex].estruturas_grupos)) {
        comps[alreadyAddedIndex].estruturas_grupos?.push({
          "@remove": item["@remove"] || undefined,
          componente_id: Number(item.componente_id),
          estruturas_grupo_id: Number(item.estruturas_grupo_id),
          quantidade: Number(item.quantidade),
        })
        comps[alreadyAddedIndex]["@remove"] = comps[alreadyAddedIndex].estruturas_grupos?.every(item => item["@remove"] === true) ? true : undefined
      } else {
        comps[alreadyAddedIndex].estruturas_grupos = [{
          "@remove": item["@remove"] || undefined,
          componente_id: Number(item.componente_id),
          estruturas_grupo_id: Number(item.estruturas_grupo_id),
          quantidade: Number(item.quantidade),
        }]
        comps[alreadyAddedIndex]["@remove"] = item["@remove"] || undefined
      }
    } else {
      comps.push({
        componente_id: Number(item.componente_id),
        categoria_componentes_id: Number(item.categoria_componentes_id),
        quantidade: Number(item.quantidade),
        valor_unitario: Number(item.valor),
        "@remove": item["@remove"] || undefined,
        estruturas_grupos: [{
          "@remove": item["@remove"] || undefined,
          componente_id: Number(item.componente_id),
          estruturas_grupo_id: Number(item.estruturas_grupo_id),
          quantidade: Number(item.quantidade),
        }]
      })
    }
  }

  return comps
}

const formatSolucaoSugerida = (data: FormProjetoOffGridType) => {
  const componentes: {id: number; quantidade: number; categoria_componentes_id: number;}[] = []

  const inversores = data.solucao_calculada.inversores || [];
  const controladores = data.solucao_calculada.controladores || [];
  const baterias = data.solucao_calculada.baterias || [];
  const acessorios = data.acessorios || [];
  const estruturas = data.estruturas_calculadas || [];
  const moduloSelecionado = data.modulo_selecionado || null;

  if (inversores.length > 0) {
    componentes.push(...inversores.map(item => {
      return {
        id: item.id,
        quantidade: item.quantidade,
        categoria_componentes_id: item.categoria_componentes_id,
      }
    }))
  }

  if (controladores.length > 0) {
    componentes.push(...controladores.map(item => {
      return {
        id: item.id,
        quantidade: item.quantidade,
        categoria_componentes_id: item.categoria_componentes_id,
      }
    }))
  }

  if (baterias.length > 0) {
    componentes.push(...baterias.map(item => {
      return {
        id: item.id,
        quantidade: item.quantidade,
        categoria_componentes_id: item.categoria_componentes_id,
      }
    }))
  }

  if (acessorios.length > 0) {
    componentes.push(...acessorios.map(item => {
      return {
        id: item.componente_id,
        quantidade: item.quantidade_original || 0,
        categoria_componentes_id: item.categoria_componentes_id,
      }
    }))
  }

  if(estruturas.length > 0){
    componentes.push(...estruturas.map(item => ({
      id: item.componente_id,
      quantidade: item.quantidade_original || 0,
      categoria_componentes_id: item.categoria_componentes_id,
    })))
  }

  if (moduloSelecionado) {
    componentes.push({
      id: moduloSelecionado.componente_id,
      quantidade: moduloSelecionado.quantidade,
      categoria_componentes_id: moduloSelecionado.categoria_componentes_id,
    })
  }

  const fileiras = data.fileiras?.map(item => ({
    posicao: item.posicao_modulo?.value,
    estrutura_id: item.tipo_estrutura?.value,
    estruturas_grupo_id: item.tipo_estrutura?.estruturas_grupo_id,
    modulos_sequencia: item.quantidade_modulos,
    fileiras_iguais: item.fileiras,
  }))

  return {
    componentes,
    fileiras,
    // potencia: data.potencia_desejada,
    // inversor: data.tipo_inversor?.value,
    regiao_id: data.regioes,
    // inversor_tensao: data.tensao_rede?.value,
    // inversor_tipo_conexao: data.numero_fases?.value,
    // tipo_projeto: data.tipo_projeto?.value,
    // fator_perdas: Number(data.fator_perdas || 0),
    // tipo_inversor: data.tipo_inversor?.value,
    tipo_bateria: data.tipo_bateria?.id,
    autonomia_banco_baterias: data.autonomia_banco_bateria,
    tensao_saida: data.tensao_saida?.id,
    potencia_fotovoltaica: data.potencia_fotovoltaica,
    geracao_necessaria_w: data.geracao_necessaria_w,
    geracao_necessaria_kw: data.geracao_necessaria_kw,
    total_consumo_diario_w: data.total_consumo_diario_w,
    total_consumo_diario_kw: data.total_consumo_diario_kw
  }
}

function getEstruturasDimensionado(data: FormProjetoOffGridType): ListagemItem[] {
  return data.estruturas_calculadas?.filter(item => Number(item.quantidade || 0) > 0) || []
}


function formatarComponentes(data: FormProjetoOffGridType): ComponentesSalvar[] {
  const componentes = []

  const moduloSelecionado = data.modulo_selecionado || null
  const inversoresAdicionados = data.solucao_calculada.inversores?.filter(item => Number(item.quantidade || 0) > 0) || []
  const controladoresAdicionados = data.solucao_calculada.controladores?.filter(item => Number(item.quantidade || 0) > 0) || []
  const bateriasAdicionadas = data.solucao_calculada.baterias?.filter(item => Number(item.quantidade || 0) > 0) || []
  const acessoriosAdicionados = data.acessorios?.filter(item => Number(item.quantidade || 0) > 0) || []
  const estruturasAdicionadas = getEstruturasDimensionado(data)

  if (moduloSelecionado) {
    componentes.push(...formatarComponentesSalvar([moduloSelecionado]))
  }

  if (inversoresAdicionados.length) {
    componentes.push(...formatarComponentesSalvar(inversoresAdicionados.map(item => ({
      ...item,
      componente_id: item.id,
      valor_unitario: 0,
      valor: 0,
    }))))
  }

  if (controladoresAdicionados.length) {
    componentes.push(...formatarComponentesSalvar(controladoresAdicionados.map(item => ({
      ...item,
      componente_id: item.id,
      valor_unitario: 0,
      valor: 0,
    }))))
  }

  if (bateriasAdicionadas.length) {
    componentes.push(...formatarComponentesSalvar(bateriasAdicionadas.map(item => ({
      ...item,
      componente_id: item.id,
      valor_unitario: 0,
      valor: 0,
    }))))
  }

  if (estruturasAdicionadas.length) {
    componentes.push(...formatarEstruturasSalvar(estruturasAdicionadas))
  }
  
  if (acessoriosAdicionados.length) {
    componentes.push(...formatarComponentesSalvar(acessoriosAdicionados))
  }

  if (!data.isEdit) {
    return componentes?.filter(i => (i?.quantidade > 0 && !i["@remove"]));
  }

  return componentes
}

function formatEquipamentos(data: FormProjetoOffGridType): EquipamentoConsumoSalvar[] {
  const toDestroy = data.equipamentos?.filter(item => !!item["@remove"] && !!item.id) || []
  const add = data.equipamentos.filter(item => item["@new"] && !item["@remove"] && !item.id) || []
  const save = data.equipamentos.filter(item => !item["@new"] && !item["@remove"]) || []

  return [
    ...add.map(item => ({ ...item, id: null })),
    ...toDestroy,
    ...save,
  ]
}

export async function salvarProjetoOffGrid(manager: VerticaisManager, id: string | number | undefined, data: FormProjetoOffGridType, usuario: ExtraInfoUsuario, clonarProjeto?: boolean): Promise<IDataResponse>  {
  const moduloSelecionado = data.modulo_selecionado || null
  const potenciaModulosEmWatts = moduloSelecionado ? (moduloSelecionado.quantidade * moduloSelecionado.potencia) : 0
  const potenciaInversoresEmWatts = [...data.solucao_calculada.inversores, ...data.solucao_calculada.controladores]?.filter(item => item.quantidade > 0).reduce((acc, curr) => acc + (curr.potencia * curr.quantidade), 0)

  const componentes = formatarComponentes(data)

  const recalcularValor = projetosProvider.confereRecalcular(componentes, data);

  const getValorServico = () => {
    if (!data.revenda_id) return 0;
    if (!data.recebe_servico) return 0
    if (data.revenda && !data.revenda?.segmentos_servico?.includes(data?.segmento?.includes("on") ? "on" : "off") && Number(data.valor_servico || 0) > 0) return 0;
    return data.valor_servico ? Number(data.valor_servico || 0) : 0
  }

  const getJustificativa = () => {
    const exibe = exibeJustificativaValorServico$.getValue();
    if (exibe === undefined) return data.justificativa_valor_servico || null
    return exibe && data.justificativa_valor_servico ? data.justificativa_valor_servico : null
  }

  const payload = {
    editar_projeto: data.isEdit,
    equipamentos: formatEquipamentos(data),
    assistente_id: data.assistente_id,
    // analista_id: data.analista_id,
    // auto_comissao: ,
    cidade_id: data.cidade?.id,
    cliente_proposta: data.cliente_proposta,
    codigo_venda: data.codigo_venda,
    cpf_cnpj_proposta: data.cpf_cnpj_proposta?.replace(/[^a-zA-Z0-9]/g,''),
    distribuidor_id: data.distribuidor_id,
    email_proposta: data.email_proposta,
    // telefone_proposta: data.telefone_proposta,
    endereco: {
      bairro: data.bairro,
      cep: data.cep?.replace(/[^\d]/g, ''),
      logradouro: data.endereco_proposta,
      numero: data.numero,
      cidade_id: data.cidade?.id,
      estado_id: data.estado?.id,
    },
    estado_id: data.estado?.id,
    ev_id: data.ev?.id || data.ev_id,
    // nota_fiscal_triangular: data.nota_fiscal_triangular,
    // observacao: data.observacao,
    // prioridade: data.prioridade,
    revenda_id: data.revenda?.id || data.revenda_id || null,
    segmento: data.segmento,
    // setor: data.setor,
    // situacao: data.situacao,
    supervisor_id: data.supervisor_id,
    tipo: data.tipo,
    titulo: data.titulo,
    servico: getValorServico() > 0 ? 'revenda' : null,
    valor_servico: getValorServico(),
    // simultaneidade: Number(data.simultaneidade || 0),
    // preco_kwh: Number(data.preco_kwh_com_imposto || 0),
    latitude: data.latitude || null,
    longitude: data.longitude || null,
    valor_servico_pis_cofins: data.revenda_id && getValorServico() > 0 ? data.valor_servico_pis_cofins : 0,
    vendedor_interno_id: data.vendedor_interno?.value || undefined,
    // texto_termo_aceito: data.texto_termo_aceito || undefined,
    // lista_termo_simulacao_financiamento: data.lista_termo_simulacao_financiamento || undefined,
    reativar: data.reativar,
    peso_gerador: data.resultado_calculos?.componentes?.peso_gerador,
    peso_telhado: data.resultado_calculos?.componentes?.peso_telhado,
    // valor_anual_manutencao: data.valor_anual_manutencao,
    // processo_v2: false,
    justificativa_valor_servico: getJustificativa(),
    // simulacao_financiamento: data.simulacao_financiamento || null,
    // tempo_garantia_servico: data.tempo_garantia_servico,
    // tempo_garantia_servico_unidade: data.tempo_garantia_servico_unidade?.value || null,
    valor: data.resultado_calculos?.componentes?.valor || 0,
    valor_projeto: Number(data.resultado_calculos?.componentes?.valor || 0) + Number(data.resultado_calculos?.servicos?.valor_com_pis_cofins || 0),
    solucao_sugerida: formatSolucaoSugerida(data),
    // valor_margem_produtos: 0,
    // dados_finalizar: data?.dados_finalizar,
    // tarifa_concessionaria_id: data?.tarifa_concessionaria_id,
    // dados_concessionaria_payback: data?.dados_concessionaria_payback,
    componentes,
    tipo_faturamento: TIPO_FATURAMENTO[0].value,
    potencia: potenciaModulosEmWatts ? DecimalUtil.toFixed(converterParaKw(potenciaModulosEmWatts), 2) : 0,
    potencia_inversor: converterParaKw(potenciaInversoresEmWatts),
  }

  let primaryKey = id || undefined;
  if (primaryKey && recalcularValor) {
    primaryKey += "?recalcular=true";

    // Atualizar proposta quando for um updade
    Object.assign(payload, { atualizar_proposta: true })
  }

  if (primaryKey && usuario?.isIntelbras) {
    Object.assign(payload, {
      editado_admin: true,
    })
  }

  // remove tag de processo_v2 quando for um updade
  // if(primaryKey){
  //   delete payload?.processo_v2;

  //   if(recalcularValor){
  //     primaryKey += "&atualizar_tarifas=true&atualizar_comissoes=true";
  //   }else{
  //     primaryKey += "?atualizar_tarifas=true&atualizar_comissoes=true";
  //   }
  // }

  if (clonarProjeto) {
    primaryKey = undefined
 
    // Remover campos que não devem ser clonados
    delete payload.assistente_id
    // delete payload.analista_id
    // delete payload.atualizar_proposta
    // delete payload.editado_admin
    delete payload.ev_id
    delete payload.supervisor_id
    
    return api.post({
      url: "/projetos/clonagem",
      data: {
        ...payload,
        projeto_original_id: id,
        clonar_via_payload: true
      }
    })
  }

  let result = await manager.save({
    row: payload,
    primaryKey: primaryKey
  })

  if (!primaryKey && result.statusCode === 400 && result.data?.[0]?.message.includes("Projeto") && result.data?.[0]?.message.includes("unique")) {
    result = await manager.save({
      row: payload,
      primaryKey: primaryKey
    })
  }

  return result
}